import fileExporter from './FileExporter'

function csvFileExporter(name, text) {
  text = text || '';
  name = name || 'Untitled'
  fileExporter(name + '.csv', text);
}

export default csvFileExporter
